<template>
  <IconWrapper v-if="filled" name="pin" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9934 2C16.6561 2 20.5 5.71789 20.5 10.3178C20.5 12.6357 19.657 14.7876 18.2695 16.6116C16.7388 18.6235 14.8522 20.3765 12.7285 21.7524C12.2425 22.0704 11.8039 22.0944 11.2704 21.7524C9.13474 20.3765 7.24809 18.6235 5.7305 16.6116C4.34198 14.7876 3.5 12.6357 3.5 10.3178C3.5 5.71789 7.34388 2 11.9934 2ZM11.9934 7.77683C10.4517 7.77683 9.19423 9.0478 9.19423 10.5768C9.19423 12.1177 10.4517 13.3297 11.9934 13.3297C13.5362 13.3297 14.8058 12.1177 14.8058 10.5768C14.8058 9.0478 13.5362 7.77683 11.9934 7.77683Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
  <IconWrapper v-else name="pin" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.75 10.5005C8.75 8.70502 10.205 7.25 12.0005 7.25C13.7952 7.25 15.25 8.70522 15.25 10.5005C15.25 12.295 13.795 13.75 12.0005 13.75C10.2052 13.75 8.75 12.2952 8.75 10.5005ZM12.0005 8.75C11.0334 8.75 10.25 9.53345 10.25 10.5005C10.25 11.4664 11.0333 12.25 12.0005 12.25C12.9665 12.25 13.75 11.4665 13.75 10.5005C13.75 9.53325 12.9664 8.75 12.0005 8.75Z"
        fill="#1B1B1E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9995 3.75C8.27735 3.75 5.25 6.79478 5.25 10.5633C5.25 12.9566 6.67999 15.3915 8.36109 17.2843C9.19047 18.2181 10.0523 18.987 10.7681 19.5165C11.1269 19.7819 11.4377 19.9788 11.6804 20.1056C11.8654 20.2023 11.9664 20.2342 11.9995 20.2448C12.0326 20.2342 12.1336 20.2022 12.3187 20.1056C12.5614 19.9788 12.8723 19.7819 13.2311 19.5165C13.947 18.987 14.809 18.218 15.6385 17.2842C17.3198 15.3914 18.75 12.9565 18.75 10.5633C18.75 6.79491 15.7218 3.75 11.9995 3.75ZM3.75 10.5633C3.75 5.97849 7.43685 2.25 11.9995 2.25C16.562 2.25 20.25 5.97836 20.25 10.5633C20.25 13.5051 18.5292 16.2886 16.7599 18.2804C15.8641 19.2889 14.9258 20.1288 14.1231 20.7225C13.7225 21.0188 13.3444 21.2621 13.0131 21.4351C12.7182 21.5892 12.347 21.75 11.9995 21.75C11.6521 21.75 11.2808 21.5892 10.9859 21.4351C10.6546 21.2621 10.2766 21.0187 9.87608 20.7225C9.07343 20.1287 8.13525 19.2888 7.23957 18.2803C5.47053 16.2885 3.75 13.5051 3.75 10.5633Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  filled?: boolean
}>()
</script>
